module.exports = __webpack_public_path__ + "static/budget-capital-banner-b9ee8199b3348759ae378d0f52cf5bd5.png";